import { Badge } from "@/components/ui/badge"

export function StatusIndicator({ active }: { active: boolean }) {
  return <Badge variant={active ? "default" : "destructive"}>{active ? "Actif" : "Inactif"}</Badge>
}
